<template>
    <section>
      <el-form ref="form" label-position="right" status-icon :model="form" :rules="rules" label-width="150px" style="width:95%;overflow:auto">
        <el-form-item label="设备编号" prop="id">
          <el-input placeholder="请输入设备编号" v-model="form.id" :disabled="row ? true : false"></el-input>
        </el-form-item>
        <el-form-item label="端口数量" prop="portQuantity">
          <el-select v-model="form.portQuantity" placeholder="请选择" :disabled="row ? true : false">
             <el-option
               v-for="item in portQuantityOptions"
               :key="item.value"
               :label="item.label"
               :value="item.value"
              >
             </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="厂商类型" prop="brandType" >
          <el-select v-model="form.brandType" placeholder="请选择">
             <el-option
               v-for="item in brandTypeOptions"
               :key="item.value"
               :label="item.label"
               :value="item.value"
              >
             </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属商户" prop="merchantId" v-if="userInfo.roleLevel < 5 && ( (row && !row.merchantId) || !row)">
          <el-select v-model="form.merchantId" placeholder="请选择所属商户" @change="chooseMerchant">
            <el-option
              v-for="item in managerUnitOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装小区" prop="unitId" v-if="userInfo.roleLevel <= 5">
          <el-select filterable remote v-model="form.unitId" clearable placeholder="请输入小区名称查询" :remote-method="getNieghbourList">
            <el-option
              v-for="item in neighbourhoodList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小区内具体安装位置" prop="address">
          <el-input placeholder="请填写具体安装位置" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" >
          <el-input placeholder="请填写备注" v-model="form.remark" type="textarea"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="handleSubmit('form')" :plain='true'>立即提交</el-button>
        </el-form-item>
      </el-form>
    </section>
  </template>
  
  <script>
  import { createChargePile,getNeighbourhoodList,updateChargePile,getMerchantList } from '@/api/public.js';
  import { onlyNumber } from '@/api/publicFun.js';
  export default {
    props:['row'], // 父组件携带参数
    data() {
      return {
        form:{ // 表单数据
          address: "", // 小区内具体安装位置
          id:'', // 设备编号
          portQuantity: "", // 设备类型
          merchantId: "", // 商户id
          type: 1, // 类型
          unitId: "", // 小区id
          remark: "" // 备注
        },
        brandTypeOptions:[ // 厂商类型选项
          {value:1,label:'友电'},
          {value:3,label:'乐电'},
        ],
        portQuantityOptions:[ // 端口数量
          {value:16,label:'16口'},
          {value:20,label:'20口'},
        ],
        rules: { // 表单验证
          id:[
            { required: true, message: '设备编号不得为空', trigger: 'blur'},
            { validator: onlyNumber, trigger: 'blur' }
          ],
          unitId:[
            { required:true,message:'安装小区不得为空',trigger:"blur"}
          ],
          merchantId:[
            { required:true,message:'所属商户不得为空',trigger:"blur"}
          ],
          address:[
            { required:true,message:'安装位置不得为空',trigger:"blur"}
          ],
          portQuantity:[
            { required:true,message:'请选择端口数量',trigger:"blur"}
          ],
          brandType:[
            { required:true,message:'请选择厂商类型',trigger:"blur"}
          ]
        },
        neighbourhoodList:[], // 小区列表
        managerUnitOptions:[], // 商户列表
        props: { // 所属商户、小区 联动选择框配置
          value:'id',
          label:'name',
          lazy: true,
          checkStrictly:true,
          lazyLoad (node, resolve) {
            const { level } = node;
            console.log(node,987)
            setTimeout(() => {
              let data = {
                pageNo:1,
                pageSize:1000,
                param:{
                  name:null,
                  merchantId:node.value,
                }
              }
              getNeighbourhoodList(data).then(res=>{
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                let nodes = [];
                res.data.list.forEach(element=>{
                  nodes.push({
                    id: element.id,
                    name: element.name,
                    leaf: level >= 1,
                    children:null,
                  })
                })
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              })
              console.log(node,908)
            }, 500);
          }
        },
        unitId:[],
        userInfo:JSON.parse(localStorage.getItem('userInfo')), // 当前登录账户信息
      };
    },
  
    components: {},
  
    computed: {},
  
    mounted() {
      this.form = this.row ? {...this.row} : this.form;
      this.getMerchantOptions();
      this.getNieghbourList(null);
    },
  
    methods: {
      // 获取小区列表
      getNieghbourList(e){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:e,
            merchantId:this.form.merchantId,
          }
        }
        getNeighbourhoodList(data).then(res=>{
          if(res.success){
            this.neighbourhoodList = res.data.list;
          }
        })
      },
      // 获取商户列表
      async getMerchantOptions(){
        let data = {
          pageNo:1,
          pageSize:1000,
          param:{
            name:'',
          }
        }
        await getMerchantList(data).then(res=>{
          if(res.success){
            this.managerUnitOptions = res.data.list;
          }else{
            this.managerUnitOptions = [];
          }
        })
      },
      // 选择商户、小区
      chooseMerchant(e){
        this.form.merchantId = e;
        this.getNieghbourList();
      },
      // 关闭弹窗
      close(form){
         this.$emit('close');
      },
      // 新增
      async add(){
        await createChargePile({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 编辑
      async edit(){
        await updateChargePile({param:this.form}).then((res) => {
          if (res.success) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            setTimeout(() => {
              this.$emit("close");
            }, 1000);
          }else{
            this.$message({
              message: res.msg,
              type: "fail",
            });
          }
        })
      },
      // 提交
      handleSubmit(form) {
        if(this.userInfo.roleLevel >= 10){
          this.form.unitId = this.userInfo.unitId;
        }
         this.$refs["form"].validate(valid => {
            if (valid) {
                this.$confirm('确认提交吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  if(this.row){
                    this.edit();
                  }else{
                    this.add();
                  }
                })
            }else{
              return false;
            }
        });
      },
    }
  };
  </script>
  <style lang="scss" scoped>
  // 防止地图自动完成的对象被遮挡
  .tangram-suggestion {
      z-index: 9999 !important;
    }
   .el-drawer{
     overflow:auto !important;
   }
   /deep/ .el-form-item__content{
    display: flex;
   }
   .map{
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    width: 80px;
   }
   .avatar-uploader .el-upload {
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      border: 1px dashed #ccc;
      border-radius: 50%;
      overflow:hidden;
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>
  